import { SelectOption } from "@src/components/elements/Select/SelectOption";
import { StylesConfig } from "react-select";

export const generateSelectStyles: (
  error?: string,
  size?: "large" | "small",
  labelType?: "normal" | "floating",
) => StylesConfig<SelectOption, false> = (error, size, labelType) => {
  return {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
    option: (provided, state) => ({
      ...provided,
      cursor: "pointer",
      border: "none",
      "&:hover": {
        color: !state.isDisabled ? "var(--dark-green)" : "",
        background: !state.isDisabled
          ? "var(--background-green)"
          : "var(--background-gray)",
        cursor: !state.isDisabled ? "pointer" : "default",
      },
      "&:active": { background: "white" },
      background: !state.isDisabled ? "white" : "var(--background-gray)",
      color: state.isSelected
        ? "var(--green) !important"
        : "var(--primary-black)",
      fontFamily: "var(--inter-font)",
      fontSize: "var(--font-size-small)",
      padding: "0.625rem 0.75rem",
      wordWrap: "break-word",
    }),
    control: (provided, state) => {
      return {
        ...provided,
        color: "white",
        "&:hover": {
          border: "1px solid var(--dark-gray)",
          boxShadow: "var(--drop-shadow-light)",
        },
        border: state.isFocused
          ? `1px solid ${error ? "red" : "var(--green) !important"}`
          : `1px solid ${error ? "red" : "var(--border-gray)"}`,
        outline: "none",
        boxShadow: state.isFocused ? "var(--drop-shadow-light)" : "none",
        padding: size === "small" ? "0" : "0.2rem",
      };
    },
    menuPortal: (provided) => {
      return {
        ...provided,
        zIndex: 100000,
      };
    },
    menuList: (provided) => {
      return {
        ...provided,
        background: "white",
        color: "var(--primary-black)",
        border: "none",
        padding: "0.5em 0em",
      };
    },
    input: (provided) => {
      return {
        ...provided,
        color: "var(--primary-black)",
        fontFamily: "var(--inter-font)",
      };
    },
    placeholder: (provided) => {
      return {
        ...provided,
        color:
          labelType === "normal"
            ? "var(--placeholder-color)"
            : "var(--border-gray)",
        fontFamily: "var(--inter-font)",
        fontSize: "var(--font-size-small)",
        width: "calc(100% - 1rem)",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
      };
    },
    singleValue: (provided) => {
      return {
        ...provided,
        whiteSpace: "normal",
      };
    },
    multiValue: (provided) => {
      return {
        ...provided,
        fontFamily: "var(--inter-font)",
      };
    },
    multiValueLabel: (provided) => {
      return {
        ...provided,
        fontFamily: "var(--inter-font)",
      };
    },
    multiValueRemove: (provided) => {
      return {
        ...provided,
        fontFamily: "var(--inter-font)",
      };
    },
    indicatorSeparator: (provided) => {
      return {
        ...provided,
        backgroundColor: "var(--secondary-black)",
        opacity: 0.1,
      };
    },
  };
};
